import { createSlice } from "@reduxjs/toolkit";
// approve, rejected;

const tabsSlice = createSlice({
  name: "tabs",
  initialState: {
    key: "approve",
    status: false,
    error: null,
  },
  reducers: {
    tabsStart: (state) => {
      state.status = true;
    },
    tabsSuccess: (state, action) => {
      state.status = false;
      state.key = action.payload;
    },
    tabsFailure: (state, action) => {
      state.status = false;
      state.key = "";
      state.error = action.payload;
    },
  },
});

export const { tabsStart, tabsSuccess, tabsFailure } = tabsSlice.actions;

export default tabsSlice.reducer;
